import React, { Component } from 'react'
import { Link } from "react-scroll";

import Images from '../helpers/images'
import { packageTitle, packageCopy, packageNote, packages, packagesOverText } from '../../lib/text'
import img from '../../assets/images/miel-lapiquera-frasco.jpg'

class Packages extends Component {
    render(){
        return (
            <div id="packages">
                <div className="container">
                    <div>
                        <h2>{ packageTitle }</h2>
                        <p>{ packageCopy }</p>
                        <p><b>{ packageNote }</b></p>
                        <div className="sep"></div>
                        <h3>ENVASES</h3>
                        {
                            packages ? (
                                <ul>
                                    {
                                        packages.map( (pack, i) => {
                                            return <li key={ i }>{ pack }</li>
                                        })
                                    }
                                </ul>
                            ) : ( '' )
                        }
                        <Link
                            className="button"
                            activeClass="active"
                            to="footer"
                            spy={true}
                            smooth={true}
                            offset={-70}
                            duration={500}
                            rel="noopener noreferrer"
                            aria-label="Consultanos"
                        >Consultanos!</Link>
                    </div>
                    <div className="image-overtext">
                        <Images url={ img } txt={ packageTitle } />
                        <p><i>{ packagesOverText }</i></p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Packages